import { Starfield } from "./Starfield";

/**
 * Fixed full-viewport sky layer for logged-in site pages (Layout).
 * Starfield, light rays, aurora, and vignette follow the event theme.
 */
export function SiteAtmosphere() {
  return (
    <div className="site-atmosphere" aria-hidden="true">
      <Starfield />
      <div className="hero-rays" />
      <div className="site-aurora" />
      <div className="site-vignette" />
    </div>
  );
}
